import { TypeOfValidations } from '../../../../constants/validation-constants'
import type { RequestValidationEventDetail } from '../../../../types/EventDetailTypes'
import type { EventDispatchQueue } from '../../../UseEventDispatchQueue'

/**
 * @memberof useDispatchRequestValidationEvent
 * @description
 * dispatches a request-validation event on the provided input
 *
 * dispatching is debounced and while debouncing it checks if at any time there was a validation-request,
 * that has TypeOfValidation.WITH_ERRORS. If that was the case, the final dispatch will generate
 * validation errors, otherwise validation will only  be silent.
 *
 * @fires RequestPartialValidation
 *
 * @param input -- the input that wil listen for a trigger
 * @param trigger -- the kind of trigger that the input should listen to
 * @param event -- the CustomEvent<RequestValidationTriggers> that should be dispatched
 * @param signal -- the abort signal that will be attached on the listener that is attached to the input
 * @param previousEvents -- registry of previously
 * */
export const dispatchRequestValidationEvent = (
    input: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement,
    event: CustomEvent<RequestValidationEventDetail>,
    dispatchDelay: number,
    queue: EventDispatchQueue<RequestValidationEventDetail>,
) => {
    const shouldTriggerErrors =
        queue.getQueuedEvent(input.name)?.event?.detail?.typeOfValidation === TypeOfValidations.WITH_ERRORS

    /* eslint-disable-next-line -- Assignment to property of function parameter
     * Deliberately mutating the event instead of creating another object. Other listeners
     * are also acting on this reference of the object
     * */
    if (shouldTriggerErrors) event.detail.typeOfValidation = TypeOfValidations.WITH_ERRORS

    queue.queueEvent(input.name, event, input, dispatchDelay)
}
